<template>
    <v-container fluid>
        <v-row>
            <v-col
                cols="12"
            >
                <v-alert
                    color="light-blue darken-4"
                    dark
                    icon="mdi-account"
                    border="top"
                    prominent
                >
                    <v-row align="center">
                        <v-col class="grow text-h4">Online Payment Transactions</v-col>
                    </v-row>
                </v-alert>
            </v-col>

            <v-col
                cols="12"
            >
                <v-card>
                    <v-card-text>
                        <v-select
                            :items="[
                                {
                                    text: 'Pending',
                                    value: 0
                                },
                                {
                                    text: 'Paid',
                                    value: 1
                                },
                                {
                                    text: 'Failed',
                                    value: 2
                                },
                            ]"
                            item-text="text"
                            item-value="value"
                            v-model="txnstatus"
                            dense
                            label="Transaction Status"
                            @change="getDataFromApiSync"
                        ></v-select>

                        <v-data-table
                            :headers="headers"
                            :items="items"
                            :options.sync="options"
                            :server-items-length="total"
                            :loading="loading"
                            class="elevation-6"
                            fixed-header
                            :single-expand="singleExpand"
                            :expanded.sync="expanded"
                            show-expand
                            item-key="_id"
                        >
                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <v-row>
                                        <template v-if="!Array.isArray(item.items)">
                                            <template v-for="(i, k) in Object.keys(item.items)">
                                                <v-col
                                                    cols="12"
                                                    :key="`paymentdetails-${item._id}-${k}`"
                                                >
                                                    <strong>{{ i }}</strong>: {{ parseFloat(item.items[i]).toLocaleString("en-US", { style: 'currency', currency: 'PHP' }) }}
                                                </v-col>
                                            </template>
                                        </template>

                                        <template v-else>
                                            <template v-for="(i, k) in item.items[0].Fees">
                                                <v-col
                                                    cols="12"
                                                    :key="`paymentdetails-${item._id}-${k}`"
                                                >
                                                    <strong>{{ i.feeType }}</strong>: {{ parseFloat(i.amount).toLocaleString("en-US", { style: 'currency', currency: 'PHP' }) }}
                                                </v-col>
                                            </template>
                                        </template>
                                    </v-row>
                                </td>
                            </template>

                            <template v-slot:item.payor="{ item }">
                                <template v-if="item.citizen_details.accounttype.toString() == 'individual'">
                                    {{ item.citizen_details.fullname_format1 }}
                                </template>

                                <template v-else>
                                    {{ item.companyname }}
                                </template>
                            </template>

                            <template v-slot:item.division="{ item }">
                                <div class="text-left">
                                    <template v-if="item.subtype">
                                        {{ item.subtype }}
                                    </template>
                                    <template v-else>
                                        <template v-if="item.division.toString().toUpperCase() == 'CHISS'">
                                            MISC
                                        </template>
                                        <template v-else>
                                            {{ item.division }}
                                        </template>
                                    </template>
                                </div>
                            </template>

                            <template v-slot:item.status="{ item }">
                                <template v-if="parseInt(item.status) == 0">
                                    <v-chip color="orange darken-2" small dark>Pending</v-chip>
                                </template>

                                <template v-else-if="parseInt(item.status) == 1">
                                    <template v-if="item.paymentgatewaystatus && parseInt(item.paymentgatewaystatus) == 1">
                                        <v-chip color="green darken-2" small dark>Paid</v-chip>
                                    </template>

                                    <template v-else-if="item.paymentgatewaystatus && parseInt(item.paymentgatewaystatus) == 0">
                                        <v-chip color="red darken-2" small dark>Failed</v-chip>
                                    </template>

                                    <template v-else>
                                        <v-chip color="green darken-2" small dark>Paid</v-chip>
                                    </template>
                                </template>

                                <template v-else>
                                    <v-chip color="red darken-2" small dark>Failed</v-chip>
                                </template>
                            </template>

                            <template v-slot:item.ornumber="{ item }">
                                <div class="text-left" v-if="parseInt(item.status) == 1 && item.ornumber && item.paymentgatewaystatus && parseInt(item.paymentgatewaystatus) == 1">
                                    <a :href="ollinkv2(item._id)" target="_blank">{{ item.ornumber }}</a>
                                </div>
                            </template>

                            <template v-slot:item.dt="{ item }">
                                <div class="text-center">{{ MomentDate(item.dt) }}</div>
                            </template>

                            <template v-slot:item.amount="{ item }">
                                <div class="text-center">{{ parseFloat(item.amount.replace(/[^\d\.]/g, '')).toLocaleString("en-US", { style: 'currency', currency: 'PHP' }) }}</div>
                            </template>

                            <template v-slot:item.paymentgateway="{ item }">
                                <div class="text-left">
                                    <template v-if="item.prepayment.api && item.prepayment.api.toString() == 'Unionbank'">
                                        UBPay
                                    </template>

                                    <template v-else>
                                        Nationlink
                                    </template>
                                </div>
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <!-- <a :href="ollink(item.ornumber, item.division)" target="_blank" v-if="parseInt(item.status) == 1 && item.ornumber">View eOR</a> -->
                                <a :href="ollinkv2(item._id)" target="_blank" v-if="parseInt(item.status) == 1 && item.ornumber && item.paymentgatewaystatus && parseInt(item.paymentgatewaystatus) == 1">View eOR</a>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import moment from "moment"

export default {
    name: 'onlinepaymentransactions',
    props: ['CheckIfLoggedInInternal'],
    metaInfo: {
        title: 'Digital Tuguegarao - Transactions',
    },
    data() {
        return {
            citizen: {},
            loading: false,
            items: [],
            total: 0,
            headers: [
                {
                    text: 'Name of Payor',
                    sortable: false,
                    value: 'payor',
                    align: 'center',
                    class: 'text-subtitle-2 font-weight-black',
                },
                {
                    text: 'E-O.R. #',
                    sortable: false,
                    value: 'ornumber',
                    align: 'center',
                    class: 'text-subtitle-2 font-weight-black',
                },
                {
                    text: 'Transaction Date',
                    sortable: false,
                    value: 'dt',
                    align: 'center',
                    class: 'text-subtitle-2 font-weight-black',
                },
                {
                    text: 'Payment Channel',
                    sortable: false,
                    value: 'paymentgateway',
                    align: 'center',
                    class: 'text-subtitle-2 font-weight-black',
                },
                {
                    text: 'Transaction Type',
                    sortable: false,
                    value: 'division',
                    align: 'center',
                    class: 'text-subtitle-2 font-weight-black',
                },
                {
                    text: 'Amount',
                    sortable: false,
                    value: 'amount',
                    align: 'center',
                    class: 'text-subtitle-2 font-weight-black',
                },
                { text: '', value: 'data-table-expand' },
            ],
            options: {},
            employeeajax: null,
            eormessage: '',
            expanded: [],
            singleExpand: true,
            txnstatus: 0
        }
    },
    watch: {
        options: {
            handler () {
                this.getDataFromApi()
                    .then(data => {
                        this.items = data.items
                        this.total = parseInt(data.total)
                    })
            },
            deep: true,
        },
    },
    methods: {
        getDataFromApiSync() {
            this.getDataFromApi()
                .then(data => {
                    this.items = data.items
                    this.total = parseInt(data.total)
                })
        },
        getDataFromApi() {
            this.loading = true

            return new Promise((resolve) => {
                const { page, itemsPerPage } = this.options
                const start_row = (parseInt(page) - 1) * parseInt(itemsPerPage)

                if(this.employeeajax){
                    this.employeeajax.cancel()
                }

                this.employeeajax = axios.CancelToken.source()

                axios({
                    url: `${this.domain}/op_transactions_coa`,
                    method: 'POST',
                    data: {
                        start_row,
                        limit: itemsPerPage,
                        status: this.txnstatus,
                    },
                    cancelToken: this.employeeajax.token
                })
                    .then(response => {
                        this.loading = false

                        if(response.data.response){
                            setTimeout(() => {
                                const items = this.$jwt.decode(response.data.items, this.jwtsecret)

                                // console.log(items)

                                resolve({
                                    items: items.items,
                                    total: response.data.total
                                })
                            }, 500)
                        } else{
                            setTimeout(() => {
                                resolve({
                                    items: [],
                                    total: 0
                                })
                            }, 500)
                        }
                    }).catch(function(err) {
                        console.log(err)

                        resolve({
                            items: [],
                            total: 0
                        })
                    })
            })
        },
        printeOR(paymentslip) {
            // const win = window.open(`http://35.220.187.169/Treasury/EORPrint.php?data={"collection":["${paymentslip}"]}`, '_blank')
            const win = window.open(`https://${window.location.hostname}/Treasury/EORPrint.php?data={"collection":["${paymentslip}"]}`, '_blank')
            win.focus()
        },
        ollinkv2(transactionid) {
            return `${this.localdomain}payments/eor/${transactionid}`
        },
        ollink(paymentslip, div = 'RPT') {
            let _link = ''

            switch(div) {
                case 'RPT':
                    // _link = `http://35.220.187.169/Treasury/EORPrint.php?data={"collection":["${paymentslip}"]}`
                    _link = `https://${window.location.hostname}/Treasury/EORPrint.php?data={"collection":["${paymentslip}"]}`
                    break;
                case 'BPLO':
                    // _link = `http://35.220.187.169/Treasury/EORBPLO.php?data=${paymentslip}`
                    _link = `https://${window.location.hostname}/Treasury/EORBPLO.php?data=${paymentslip}`
                    break;
                case 'CHISS':
                    _link = `https://${window.location.hostname}/Treasury/MiscEOR.php?data=${paymentslip}`
                    break;
            }

            return _link
        },
        MomentDate(dt) {
            return moment(parseInt(dt) * 1000).format('MMM D, YYYY h:mm A')
        }
    },
    mounted() {
        this.CheckIfLoggedInInternal()

        const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)
        user.mobile = user.mobile || ''
        delete user.passwd
        delete user.signature

        this.citizen = _.cloneDeep(user)

        // check
        this.CRM_Interval = setInterval(() => {
            if(!(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature'))){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'login'
                }).catch(()=>{})
            }
        }, 500)
    }
}
</script>